import React, { FC, useEffect, useState } from "react";
import { AEATabs, AEATab, FormProaSubproject, ProaSummary, FormProaFE } from "@/components/";
import { Container } from "reactstrap";
import { FormProaPresenter } from "../../../../presenters/screens/form-proa.presenter";
import { IProaForm } from "@interfaces/screens/proa-form.interface";
import { String } from "@utils";
import { FaLayerGroup } from "react-icons/fa";
import styles from './form-proa.module.scss';

const FormProa: FC<any> = () => { 
  const [feTabs, setFeTabs] = useState({tabsShow:[], tabsArray:[], tabstabsEmpty:[]});
  const [results, setResults] = useState<any>([]);
  const [columns, setColumns] = useState<any>({FFRR: null, FFEE: null});
  const [summaryData, setSummaryData] = useState<any>({appMasters: null, dataColumns: null});
  const [consultFe, setConsultFE] = useState(false);

  const view: IProaForm = {
    state: {
      columns,
      setColumns,
      setSummaryData
    },
  };

  const presenter = new FormProaPresenter(view);

  useEffect(() => {
    if(presenter.currentLang?.id) presenter.initializeForm();
  }, [presenter.currentLang]);

  useEffect(() => {
    if(presenter.currentLabels?.values?.length !== 0  && !!columns.FFRR && consultFe && !!summaryData.appMasters) presenter.unSetLoading();
  }, [columns, presenter.currentLabels, consultFe, summaryData]);

  useEffect(() => {
    if(presenter.currentBudgetDetails && presenter.currentBudget && !!presenter.projectsGrouped){
      let tabs: any = presenter.getFormFeTabs();
      setFeTabs(tabs)
      setConsultFE(true)
    }
  }, [presenter.currentBudgetDetails, presenter.currentBudget, presenter.projectsGrouped]);

  useEffect(() => {
    if(presenter.currentLabels?.values?.length !== 0 && !!presenter.projectsGrouped && consultFe && !!columns.FFRR && !!summaryData.appMasters){
      const  res = []

      res.unshift(
        <AEATab title={presenter.currentLabels.get("ProaTab-Resumen general")}>
          <ProaSummary
            basicDataColumnDefinition={summaryData.dataColumns}
            currentApplicationMasters={summaryData.appMasters}
            projectsGrouped={presenter.projectsGrouped}
          ></ProaSummary>
        </AEATab>,
        <AEATab title={presenter.currentLabels.get("ProaTab-Subproyectos ffrr")} >
          <FormProaSubproject
            dataColumns={columns.FFRR}
          ></FormProaSubproject>
        </AEATab>,
      );

      if (feTabs.tabsShow.length > 0) {
        feTabs.tabsShow.forEach((tab: any, index: number) => {
          let tabTitle = tab.grouped ? <div className={styles.FaLayerGroup}><FaLayerGroup></FaLayerGroup></div> : '';
          let title = <div className={styles.tabTitle}>{tabTitle}{presenter.currentLabels.get("ProaTab-subproyectos ffcc") + " " + tab.title }</div>;
          res.push(
            <AEATab title={title} >
              <FormProaFE
                dataColumns={columns.FFEE}
                projectsGrouped={presenter.projectsGrouped}
                subventionCodeId={tab.id}
                index={index}
                grantCode={tab.grantCode}
                forceLoad={feTabs.tabsShow.length > 0 ? false : true}
              ></FormProaFE>
            </AEATab>
          );
        });
      } 
      setResults(res)
    }
  }, [presenter.currentLabels, feTabs, presenter.projectsGrouped, columns, consultFe, summaryData]);

  return (
    <Container fluid={true}>
      <h5>
        {presenter.currentBudget
          ? String.Format("{0} - {1}", presenter.currentBudget?.PPresCodProy ?? "", presenter.currentBudget?.Title ?? "")
          : ""
        }
      </h5>
      <br />
      {(presenter.currentLabels?.values?.length !== 0) && <AEATabs defaultTab={0} children={results}></AEATabs>}
    </Container>
  );
};
export default FormProa;
